import * as React from "react";
import { clsx } from "@plans/appkit";
import { dangerouslyParseMarkdown } from "~/lib/utils/dangerously-parse-markdown";

export type RichTextProps = {
	className?: string;
	children?: React.ReactNode | string;
};

export function RichText({ children, className }: RichTextProps) {
	const parsedMarkdown = React.useMemo(
		() =>
			typeof children === "string"
				? dangerouslyParseMarkdown(children)
				: undefined,
		[children],
	);
	if (parsedMarkdown) {
		return (
			<div
				className={clsx("global-richtext-content contents", className)}
				dangerouslySetInnerHTML={{ __html: parsedMarkdown }}
			/>
		);
	}
	return (
		<div className={clsx("global-richtext-content contents", className)}>
			{children}
		</div>
	);
}
